"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardPhoto = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardPhotoMixin = require("../../mixins/components/PropertyCardPhotoMixin");
var StyledPropertyCardPhoto = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardPhoto",
  componentId: "c11n-8-107-0__sc-radyfj-0"
})(["", ""], _PropertyCardPhotoMixin.PropertyCardPhotoMixin);
exports.StyledPropertyCardPhoto = StyledPropertyCardPhoto;